<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="所属组织">
          <el-select v-model="formInline.organization" placeholder="请选择所属组织" clearable filterable style="width: 200px;">
            <el-option v-for="item in companyList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="综合查询">
          <el-input placeholder="请输入姓名/身份证号/手机号" v-model="formInline.search" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="账号状态">
          <el-select v-model="formInline.account_status" placeholder="请选择账号状态" clearable style="width: 150px;">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="请选择状态" clearable style="width: 150px;">
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监督员身份">
          <el-checkbox-group v-model="formInline.identity">
            <el-checkbox label="1">安全监督员</el-checkbox>
            <el-checkbox label="2">质量监督员</el-checkbox>
            <el-checkbox label="3">环保监督员</el-checkbox>
            <el-checkbox label="4">消防监督员</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加监督员</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="name" label="姓名" width="100"></el-table-column>
            <el-table-column prop="id_card" label="身份证号" width="180"></el-table-column>
            <el-table-column prop="organization_name" label="所属组织" width="150"></el-table-column>
            <el-table-column prop="employee_identity" label="员工身份" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.employee_identity === '1'">正式员工</span>
                <span v-else-if="scope.row.employee_identity === '2'">临时员工</span>
                <span v-else-if="scope.row.employee_identity === '3'">外包员工</span>
                <span v-else-if="scope.row.employee_identity === '4'">实习员工</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="identity" label="监督员身份" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.identity">
                  <el-tag v-if="scope.row.identity.includes('1')" size="mini" style="margin-right: 5px;">安全监督员</el-tag>
                  <el-tag v-if="scope.row.identity.includes('2')" size="mini" style="margin-right: 5px;">质量监督员</el-tag>
                  <el-tag v-if="scope.row.identity.includes('3')" size="mini" style="margin-right: 5px;">环保监督员</el-tag>
                  <el-tag v-if="scope.row.identity.includes('4')" size="mini">消防监督员</el-tag>
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="account_status" label="账户状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.account_status === '1' || scope.row.account_status === 1" type="success">正常</el-tag>
                <el-tag v-else type="danger">禁用</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === '1' || scope.row.status === 1" type="success">在职</el-tag>
                <el-tag v-else type="danger">离职</el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">详情</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="resetPasswordClick(scope.row)" type="text" size="small">重置密码</el-button>
                <el-button @click="resignClick(scope.row)" type="text" size="small">离职</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ma_supervisor_id="ma_supervisor_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Detail :open_detail="open_detail" :ma_supervisor_id="ma_supervisor_id" v-if="open_detail" @close="closeDetail"></Detail>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

    <el-dialog title="重置密码" :visible.sync="resetPasswordDialogVisible" @close='resetPasswordDialogVisible = false' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true" width="400px">
      <el-form :model="resetPasswordForm" :rules="resetPasswordRules" ref="resetPasswordForm" label-width="100px">
        <el-form-item label="新密码" prop="password">
          <el-input v-model="resetPasswordForm.password" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="resetPasswordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetPasswordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitResetPassword">确 定</el-button>
      </div>
    </el-dialog>
  
  </div>
</template>

<script>
  import Ma_supervisorApi from '@/api/ma_supervisor.js';
  import Ma_companyApi from '@/api/ma_company.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Detail from './part/detail.vue';

  export default {
    components: {
      Add,
      Edit,
      Detail,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          organization:"",
          account_status:"",
          status:"",
          identity:[]
        },
        /*组织列表*/
        companyList: [],
        open_add:false,
        open_edit:false,
        open_detail:false,
        ma_supervisor_id:"",
        dialogVisible:false,
        resetPasswordDialogVisible:false,
        resetPasswordForm: {
          password: '',
          confirmPassword: ''
        },
        resetPasswordRules: {
          password: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, message: '请再次输入新密码', trigger: 'blur' },
            { validator: this.validateConfirmPassword, trigger: 'blur' }
          ]
        },
        currentResetUserId: null,
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
      /*获取组织列表*/
      this.getCompanyList();
    },
    methods: {
      validateConfirmPassword(rule, value, callback) {
        if (value !== this.resetPasswordForm.password) {
          callback(new Error('两次输入的密码不一致'));
        } else {
          callback();
        }
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//监督员标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    closeDetail(e){
      this.open_detail=false;
    },
    getData(){
      this.getTableList();
    },
      /*获取组织列表*/
      getCompanyList() {
        let self = this;
        Ma_companyApi.list({}, true)
          .then(data => {
            self.companyList = data.data.list.data;
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        if (Params.identity && Params.identity.length > 0) {
          Params.identity = Params.identity.join(',');
        } else {
          delete Params.identity;
        }
        self.loading = true;
        Ma_supervisorApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.ma_supervisor_id = row.ma_supervisor_id;
        this.open_edit = true
      },

      /*查看详情*/
      detailClick(row) {
        this.ma_supervisor_id = row.ma_supervisor_id;
        this.open_detail = true;
      },

      /*重置密码*/
      resetPasswordClick(row) {
        this.currentResetUserId = row.ma_supervisor_id;
        this.resetPasswordForm.password = '';
        this.resetPasswordForm.confirmPassword = '';
        this.resetPasswordDialogVisible = true;
        if (this.$refs.resetPasswordForm) {
          this.$refs.resetPasswordForm.clearValidate();
        }
      },

      /*提交重置密码*/
      submitResetPassword() {
        let self = this;
        this.$refs.resetPasswordForm.validate((valid) => {
          if (valid) {
            Ma_supervisorApi.resetPassword({
              ma_supervisor_id: self.currentResetUserId,
              password: self.resetPasswordForm.password
            }, true)
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '重置密码成功',
                  type: 'success'
                });
                self.resetPasswordDialogVisible = false;
              } else {
                self.$message.error(data.msg || '重置密码失败');
              }
            })
            .catch(error => {
              self.$message.error('重置密码失败');
            });
          } else {
            return false;
          }
        });
      },

      /*离职*/
      resignClick(row) {
        let self = this;
        self.$confirm('您确定要离职该员工吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          Ma_supervisorApi.resign({
            ma_supervisor_id: row.ma_supervisor_id
          }, true)
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '设置离职成功',
                type: 'success'
              });
              this.getTableList();
            } else {
              self.$message.error(data.msg || '设置离职失败');
            }
          })
          .catch(error => {
            self.$message.error('设置离职失败');
          });
        })
        .catch(() => {});
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Ma_supervisorApi.del(
              {
                ma_supervisor_id: row.ma_supervisor_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ma_supervisor/index/index.vue